<div class="container">
    <div class="left-content"></div>
    <div class="mid-content">
        <ng-content></ng-content>
    </div>
</div>